var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock_open_round [#708]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-63.000000, -5079.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,4936.00012 C19,4936.55212 18.552,4937.00012 18,4937.00012 L10,4937.00012 C9.448,4937.00012 9,4936.55212 9,4936.00012 L9,4928.00012 C9,4927.44812 9.448,4927.00012 10,4927.00012 L18,4927.00012 C18.552,4927.00012 19,4927.44812 19,4928.00012 L19,4936.00012 Z M12,4925.00012 L12,4923.13212 C12,4922.33412 12.417,4921.56112 13.133,4921.20912 C14.353,4920.60912 15.54,4921.39112 15.894,4922.39712 C16.026,4922.77212 16.408,4923.00012 16.805,4923.00012 L16.805,4923.00012 C17.485,4923.00012 17.993,4922.32212 17.749,4921.68712 C17.052,4919.86812 14.995,4918.45712 12.78,4919.20412 C11.072,4919.78012 10,4921.48612 10,4923.28812 L10,4925.00012 L10,4925.00012 C8.343,4925.00012 7,4926.34312 7,4928.00012 L7,4936.00012 C7,4937.65712 8.343,4939.00012 10,4939.00012 L18,4939.00012 C19.657,4939.00012 21,4937.65712 21,4936.00012 L21,4928.00012 C21,4926.34312 19.657,4925.00012 18,4925.00012 L12,4925.00012 Z",
    id: "lock_open_round-[#708]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "res/media/unlock.30137e2961369c6ab7a476001ef40ee5.svg";
export { ForwardRef as ReactComponent };